/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "empermissions": {
        "nested": {
          "displaypermissions": {
            "nested": {
              "PermissionGroupFlag": {
                "values": {
                  "GROUP_DO_NOT_USE": 0,
                  "TIMECARDS": 1,
                  "DISCOUNTS": 2,
                  "CHECKOUT": 3,
                  "ITEMS": 4,
                  "EMPLOYEES": 5,
                  "UNSORTED": 6,
                  "CUSTOMERS": 7,
                  "INVOICES": 8,
                  "ORDERS": 9,
                  "CAPITAL": 10,
                  "TEAM_MANAGEMENT": 11,
                  "MARKETING": 12,
                  "TRANSACTIONS": 13,
                  "REPORTS": 14,
                  "APPOINTMENTS": 15,
                  "DEPOSITS": 16,
                  "ONLINE_STORE": 17,
                  "ACCOUNT_SETTINGS": 18,
                  "RISK_MANAGER": 19,
                  "LOYALTY": 21,
                  "CONTRACTS": 22,
                  "ONLINE_STORE_ACCESS": 23,
                  "MESSENGER": 24,
                  "SUBSCRIPTIONS": 25,
                  "HOUSE_ACCOUNTS": 26,
                  "ONLINE_CHECKOUT": 27,
                  "TEAM_COMMUNICATION": 28,
                  "HR_MANAGER": 29,
                  "DEVELOPERS": 30,
                  "PAYROLL": 31
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.empermissions?.nested?.displaypermissions?.nested?.PermissionGroupFlag) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE PermissionGroupFlag @ squareup/empermissions/displaypermissions/permission_group_flags.proto at 7:1
 */
export const PermissionGroupFlag = $root.lookupEnum('squareup.empermissions.displaypermissions.PermissionGroupFlag').values;